import { render, staticRenderFns } from "./receivedListDetail.vue?vue&type=template&id=0931c2b3&"
import script from "./receivedListDetail.vue?vue&type=script&lang=js&"
export * from "./receivedListDetail.vue?vue&type=script&lang=js&"
import style0 from "./receivedListDetail.vue?vue&type=style&index=0&id=0931c2b3&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports